"use client";
import { FunctionComponent } from "react";
import dynamic from "next/dynamic";
import { ADMIN_APP_TOKEN_ID } from "@chatsystem/common/config";

const App = dynamic(() => import("@chatsystem/client").then((mod) => mod.App), {
  ssr: false,
});

interface BubbleChatWrapperProps {}

const BubbleChatWrapper: FunctionComponent<BubbleChatWrapperProps> = () => {
  return (
    <div>
      <App appToken={ADMIN_APP_TOKEN_ID} />
    </div>
  );
};

export default BubbleChatWrapper;
